export const RESET = 'RESET';
export const VISIBLE_FIELDS = 'VISIBLE_FIELDS';
export const EMAIL = 'EMAIL';
export const TOKEN = 'TOKEN';
export const PASSWORD = 'PASSWORD';
export const PASSWORD_CONFIRMATION = 'PASSWORD_CONFIRMATION';
export const ERRORS = 'ERRORS';
export const CHANGED = 'CHANGED';
